import './_language.js';

window.addEventListener("load", function () {
  const languageInput = document.querySelector('#frame1 .language #language');
  const languageContainer = document.querySelector('#frame1 .language');

  if (languageInput && languageContainer) {
    document.addEventListener('click', function (event) {
      const isClickOutside = !languageContainer.contains(event.target);
      if (isClickOutside && languageInput.checked) {
        languageInput.checked = false;
      }
    });
  }
});
